/* eslint no-param-reassign: "off" */
/* eslint no-return-assign: "off" */
const formEndpoint = 'credit_form';

function creditFormSubmit(event) {
  event.preventDefault();
  event.stopImmediatePropagation();
  const form = event.target;
  const responseElements = Array.prototype.slice.call(form.querySelectorAll('.credit-form__response'));
  const submitButtons = Array.prototype.slice.call(form.querySelectorAll('button[type="submit"], input[type="submit"]'));
  const inputFields = Array.prototype.slice.call(form.querySelectorAll('.credit-form__form-input, .checkbox__input, .radio-button__input'));
  form.classList.remove('credit-form__form--error');
  form.classList.remove('credit-form__form--failed');
  form.classList.remove('credit-form__form--response');
  form.classList.remove('credit-form__form--success');
  form.classList.add('credit-form--loading');
  responseElements.forEach(el => el.innerHTML = ''); // Clear previous response messages

  // Sending successful
  function onSubmitLoad() {
    form.classList.remove('credit-form__form--loading');

    if (this.status === 200) {
      form.classList.add('credit-form__form--success');
    } else {
      form.classList.add('credit-form__form--error');
      submitButtons.forEach((btn) => {
        btn.disabled = false; // Re-enable buttons
        btn.classList.remove('button--loading'); // Remove loading wheel
      });
      inputFields.forEach(input => input.disabled = false); // Re-enable input fields
    }

    // If there was a response, show it
    if (this.response) {
      form.classList.add('credit-form__form--response');
      responseElements.forEach(el => el.innerHTML = this.response);
    }
  }

  // Sending failed
  function onSubmitFailed() {
    form.classList.remove('credit-form__form--loading');
    form.classList.add('credit-form__form--failed');
    form.classList.add('credit-form__form--failed');
    submitButtons.forEach((btn) => {
      btn.disabled = false; // Re-enable buttons
      btn.classList.remove('button--loading'); // Remove loading wheel
    });
    inputFields.forEach(input => input.disabled = false); // Re-enable input fields
  }

  const xhr = new XMLHttpRequest();
  xhr.open('POST', window[formEndpoint].ajaxurl);
  xhr.addEventListener('load', onSubmitLoad);
  xhr.addEventListener('error', onSubmitFailed);
  const data = new FormData(form);
  data.append('action', formEndpoint);
  data.append('security', window[formEndpoint].security);
  xhr.send(data);

  submitButtons.forEach((btn) => {
    btn.disabled = true; // Disable buttons while loading
    btn.classList.add('button--loading'); // Show loading wheel
  });
  inputFields.forEach(input => input.disabled = true); // Disbale input fields while loading
}

function setup() {
  Array.prototype.forEach.call(
    document.querySelectorAll('.credit-form'),
    form => form.addEventListener('submit', creditFormSubmit)
  );
}

window.addEventListener('DOMContentLoaded', setup);
